import styled from '@emotion/styled';
import { Text } from '@innovationdepartment/proxima-ui';
import { ChatGreetingViewProps } from './types';
import ChatGreetingNoIntegrationsConnected from './ChatGreeting.NoIntegrationsConnected';

const GreetingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & h4 {
    font-weight: 400;
  }
`;

const ChatGreetingView = (props: ChatGreetingViewProps) => {
  const { username, isConnected } = props;

  return (
    <GreetingWrapper>
      <Text variant="h2" isTermina={false} color="neutral100">
        Hello{username ? `, ${username}` : ''}!
      </Text>
      {isConnected ? (
        <Text variant="h4" isTermina={false} color="neutral70">
          What can I help you with?
        </Text>
      ) : (
        <ChatGreetingNoIntegrationsConnected {...props} />
      )}
    </GreetingWrapper>
  );
};

export default ChatGreetingView;
